import AyudanteSesion from './AyudanteSesion'

function normalizeBase(base){
	return String(base || '').replace(/\/+$/, '') + '/'
}

function isLocalHost(host){
	const h = String(host || '').toLowerCase()
	return h === 'localhost' || h === '127.0.0.1' || h === '::1'
}

function detectApiBases(){
	if(typeof window === 'undefined') return ['http://localhost/grupos_lldm/api/']

	const overrideLs = localStorage.getItem('apiBaseOverride') || ''
	const overrideWin = window.__API_BASE__ || ''
	const override = String(overrideWin || overrideLs || '').trim()

	const protocol = window.location.protocol || 'http:'
	const host = window.location.hostname || 'localhost'
	const origin = window.location.origin

	if(override){
		return [normalizeBase(override)]
	}

	if(isLocalHost(host)){
		// En dev con Vue (localhost:8080), la API vive en Apache/XAMPP (sin puerto 8080)
		return [normalizeBase(`${protocol}//${host}/grupos_lldm/api/`)]
	}

	// Producción: priorizar /grupos_lldm/api y fallback a /api
	return [
		normalizeBase(`${origin}/grupos_lldm/api/`),
		normalizeBase(`${origin}/public/grupos_lldm/api/`),
		normalizeBase(`${origin}/api/`)
	]
}

let RUTA_GLOBAL = detectApiBases()[0]

function authHeaders(){
	const headers = { 'Content-Type': 'application/json' }
	const token = localStorage.getItem('token') || null
	if(token) headers['Authorization'] = 'Bearer ' + token
	return headers
}

async function parseResponse(respuesta){
	try{
		const contentType = respuesta.headers.get('content-type') || ''
		if(contentType.indexOf('application/json') !== -1) return await respuesta.json()
		const text = await respuesta.text()
		console.error('HttpService: respuesta no JSON:', text)
		return text
	}catch(e){
		try{ return await respuesta.text() }catch(_){ return null }
	}
}

function isRetriableStatus(code){
	return code === 404 || code === 405
}

async function fetchConFallback(ruta, opciones){
	const detectadas = detectApiBases()
	const bases = [RUTA_GLOBAL, ...detectadas.filter(b => b !== RUTA_GLOBAL)]
	let ultimoResultado = null

	for(const base of bases){
		let respuesta = null
		let resultado = null
		try{
			respuesta = await fetch(base + ruta, opciones)
			resultado = await parseResponse(respuesta)
		} catch(e){
			ultimoResultado = { error: true, mensaje: 'Error de red', detalle: e && e.message ? e.message : String(e) }
			continue
		}

		// Token expirado o rechazado por el servidor: cerrar sesión y volver al login
		if(resultado && resultado.error === 'Token inválido'){
			AyudanteSesion.cerrarSesion()
			return resultado
		}

		if(respuesta.ok){
			RUTA_GLOBAL = base
			return resultado
		}

		ultimoResultado = resultado
		if(!isRetriableStatus(respuesta.status)) return resultado
	}

	return ultimoResultado
}

const HttpService =  {
	async registrar(ruta, datos) {
		// inyectar grupo seleccionado automáticamente si aplica
		try{ if (datos && typeof datos === 'object' && !Object.prototype.hasOwnProperty.call(datos, 'grupoSeleccionado')) {
			const g = localStorage.getItem('grupoSeleccionado')
			if (g) datos.grupoSeleccionado = Number(g)
		} } catch(e){ void e }
		let resultado = await fetchConFallback(ruta, {
			method: "post",
			headers: authHeaders(),
			body: JSON.stringify(datos),
		});
		return resultado
	},

	async obtener(ruta) {
		let resultado = await fetchConFallback(ruta, { headers: authHeaders() })
		return resultado
	},

	async editar(ruta, datos) {
		try{ if (datos && typeof datos === 'object' && !Object.prototype.hasOwnProperty.call(datos, 'grupoSeleccionado')) {
			const g = localStorage.getItem('grupoSeleccionado')
			if (g) datos.grupoSeleccionado = Number(g)
		} } catch(e){ void e }
		let resultado = await fetchConFallback(ruta, {
			method: "post",
			headers: authHeaders(),
			body: JSON.stringify(datos),
		});
		return resultado
	},

	async eliminar(ruta, datos) {
		try{ if (datos && typeof datos === 'object' && !Object.prototype.hasOwnProperty.call(datos, 'grupoSeleccionado')) {
			const g = localStorage.getItem('grupoSeleccionado')
			if (g) datos.grupoSeleccionado = Number(g)
		} } catch(e){ void e }
		let resultado = await fetchConFallback(ruta, {
			method: "post",
			headers: authHeaders(),
			body: JSON.stringify(datos),
		});
		return resultado
	},

	async obtenerConConsultas(ruta, payload){
		try{ if (payload && typeof payload === 'object' && !Object.prototype.hasOwnProperty.call(payload, 'grupoSeleccionado')) {
			const g = localStorage.getItem('grupoSeleccionado')
			if (g) payload.grupoSeleccionado = Number(g)
		} } catch(e){ void e }
		let resultado = await fetchConFallback(ruta, {
			method: "post",
			headers: authHeaders(),
			body: JSON.stringify(payload),
		});
		return resultado
	},

	obtenerDatosNegocio(){
		return this.obtener("configuracion/obtener_datos.php")
	}
}

export default HttpService